import React from 'react'

import { Field } from 'formik'

import { Col, Form, Row } from '_zari/core'

import * as ActivosFijosService from 'services/activosFijos.service'

import { TiposMovimientoActivo } from 'constants/index'

import { KeyEventUtil } from 'utils'


const ActivoFijoFormGroup = ({ iError, iTouched, iCuentaContable, fIsSubmitting, handleChange, setFieldValue  }) => {
  const [activosFijos, setActivosFijos] = React.useState([])

  React.useEffect(() => {
    ActivosFijosService.getSelect({ cuenta: iCuentaContable })
      .then(({ data }) => {
        setActivosFijos(data)
      })
      .catch(() => setActivosFijos([]))
  }, [iCuentaContable])

  const onKeyDownPrimero = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('modal-select-ActivoFijo', e)
  }, [])

  const onChange = React.useCallback(
    e => {
      handleChange(e)
      const matchedActivo = activosFijos.find(x => x._id === e.target.value)
      if (matchedActivo) {
        setFieldValue('activoFijoInfo', matchedActivo.nombre)
      } else {
        setFieldValue('activoFijoInfo', '')
      }
    },
    [handleChange, setFieldValue, activosFijos]
  )

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('modal-nuevoasiento-agregar-button', e)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='ACTIVO FIJO' htmlFor='modal-select-tipoMovimientoActivo' md={12} />
        <Col md={12}>
          <Row>
            <Col md={4}>
              <Field name='tipoMovimientoActivo'>
                {({ field }) => (
                  <Form.Select
                    {...field}
                    id='modal-select-tipoMovimientoActivo'
                    isInvalid={iTouched && iError}
                    disabled={fIsSubmitting}
                    onKeyDown={onKeyDownPrimero}
                  >
                    <option value=''>Seleccionar</option>
                    <option value={TiposMovimientoActivo.SALDO_INICIAL}>1 Saldo Inicial</option>
                    <option value={TiposMovimientoActivo.ADICIONES}>2 Adiciones</option>
                    <option value={TiposMovimientoActivo.MEJORAS}>3 Mejoras</option>
                    <option value={TiposMovimientoActivo.RETIROS}>4 Retiros</option>
                    <option value={TiposMovimientoActivo.OTROS}>5 Otros</option>
                  </Form.Select>
                )}
              </Field>
            </Col>
            <Col md={6}>
                <Field name='_idActivoFijo'>
                  {({ field }) => (
                    <Form.Select
                      {...field}
                      id='modal-select-ActivoFijo'
                      isInvalid={iTouched && iError}
                      disabled={fIsSubmitting}
                      onChange={onChange}
                      onKeyDown={onKeyDown}
                    >
                      <option value=''>Seleccionar</option>
                      {activosFijos.map((x, k) => (
                        <option key={k} value={x._id}>
                          {x.nombre}
                        </option>
                      ))}
                    </Form.Select>
                  )}
                </Field>
            </Col>
          </Row>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(ActivoFijoFormGroup)
